import "@fontsource-variable/fraunces";
import "@fontsource-variable/inter";
import "./styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { CourseSite } from "@bodemleven/course-kit/react";
import { brand } from "./brand.ts";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <CourseSite brand={brand} />
  </StrictMode>,
);
